module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "thehistoryof32"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("The antagonism against foreigners remained strong in the Russian army during the Napoleonic Wars. From 1806 to 1807, the “Russian” officers opposed the appointment of Levin Bennigsen to command the Russian army, noting that there were genuine Russian commanders available for this post. During the campaign, bickering between Generals Bennigsen and Buxhöwden led to the latter’s dismissal (Buxhöwden later challenged Bennigsen to a duel). In June 1807, Bennigsen launched an offensive around Guttstadt, hoping to destroy Marshal Michel Ney’s corps. However, General Fabian Osten-Sacken’s column failed to support Prince Bagration’s attack, allowing the French to safely retreat. Some claimed General Sacken, who had strained relations with Bennigsen, intentionally delayed the advance to undermine the entire operation and have Bennigsen removed from the army."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent94",
      "id": "theft94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])])]), _vm._v(" In a letter to Alexander, Bennigsen accused Sacken of insubordination and held him responsible for the failure of the maneuver at Guttstadt."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent95",
      "id": "theft95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])]), _vm._v(" Sacken, who was eventually court-martialed, tried to justify his actions by referring to Bennigsen’s confusing orders."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent96",
      "id": "theft96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("A more important conflict took place during the 1812 Campaign, which could have led to disastrous consequences for Russia. This disagreement illustrates the complexities and intrigues swirling through the Russian officer corps. When Napoleon invaded Russia in June 1812, the Russian armies quickly retreated eastward. Mikhail Barclay de Tolly’s First Western Army moved toward the entrenched camp at Drissa, seeking a junction with the Second Western Army of General Peter Bagration. After marching through Drissa and Vitebsk, the First Western Army finally arrived at Smolensk on 1 August. Meanwhile, Bagration’s Second Western Army out-marched Marshal Davout’s entrapment at Moghilev and proceeded to Smolensk. Bagration himself arrived there on 2 August to discuss war plans with Barclay de Tolly."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent97",
      "id": "theft97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("This meeting influenced the fate of the Russian army. The continuous retreat was generating discontent and demoralizing the soldiers. Most senior officers, including Bagration, opposed Barclay de Tolly’s Fabian (passive) defensive strategy. Though Bagration agreed with Barclay on the necessity of the retreat, he also insisted on “active defensive warfare,” which meant combining the retreat with counterattacks."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent98",
      "id": "theft98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])])]), _vm._v(" The discord that developed between Barclay and Bagration was neither a simple quarrel between two generals nor a mere disagreement on strategy. This conflict stemmed from a political friction between the “foreigners” and old Russian aristocracy. The “real” Russian preferred a straightforward, stand-up fight to maneuvering, and bitterly resented the surrender of every inch of Russian soil, blaming the foreigners for all their misfortunes."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent99",
      "id": "theft99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The main reason for this tension was the different views on strategy among the senior officers and army commanders, who represented opposing factions within the officer corps. Barclay de Tolly"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent100",
      "id": "theft100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])])]), _vm._v(" was surrounded by the so-called “German party,” which consisted mainly of the émigré officers, some of whom settled in Russia generations earlier. These non-Russians did not form a homogeneous or isolated group in the army or in noble society generally. Many of them assimilated into the Russian society and learned the Russian language. However, in 1812, many of these non-Russians, led by Barclay de Tolly, supported a defensive doctrine. Opposing them was the “Russian party” of old Russian families who were proponents of offensive warfare. Led by Prince Peter Bagration (a Georgian), they reflected the majority opinion of the Russian army which believed in defeating Napoleon with vigorous counterattacks and offensive action."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent101",
      "id": "theft101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Prince Bagration and most Russian generals resented foreign officers in the army, claiming they brought the spirit and influence of the Prussian military into the Russian army. In a letter to Aleksey Arakcheyev, Chief of Imperial Chancellery, Bagration complained, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("“")]), _vm._v("the whole headquarters is so full of Germans that a Russian cannot breathe.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent102",
      "id": "theft102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])])]), _vm._v(" Bagration described Barclay’s headquarters in a letter to Prince Paul Stroganov, specifying that “people around the minister [Barclay de Tolly] wish to become field marshals without reading any military journals or [other writings]…. Today the rogues and impudent upstarts are in favor.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent103",
      "id": "theft103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])])]), _vm._v(" Denis Davidov, who later became a famous guerrilla leader, recalled that “inspired with ardent love of our mother land, Prince [Bagration], with unrestrained ardor characteristic of all Asians, felt anger against Barclay; this feeling, based only on antipathy to the German party, increased considerably due to constant retreat of our troops.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent104",
      "id": "theft104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Personal relations between Bagration and Barclay de Tolly were complex. The generals were cordial when they fought in the Polish campaigns (1806-1807) and the Swedish War in Finland (1808-1809). According to a contemporary, “after the battles at Pultusk and Eylau, Prince Bagration respected Barclay de Tolly and often praised him.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent105",
      "id": "theft105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])])]), _vm._v(" In 1812, however, their relationship rapidly deteriorated.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Barclay de Tolly had to perform under a significant moral stress. Most of the army opposed him, believing that the deep retreat into Russia was proof of his betrayal. Even his own staff members, led by General Alexander Ermolov, intrigued against him."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent106",
      "id": "theft106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])])]), _vm._v(" Officers taught the rank and file to call Barclay de Tolly by the nickname “Boltai da i tolko” (All talk and nothing else)."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent107",
      "id": "theft107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])])]), _vm._v(" Barclay de Tolly’s position was a precarious one from the outset of the campaign. Confidence in him was undermined, and every new stage of the retreat intensified the malicious rumors against him. It was hard for him to parry Bagration’s thrusts. Barclay had neither a heroic career nor a brilliant reputation as a disciple of Suvorov. He lacked everything Bagration had in abundance. A diligent administrator and reformer, Barclay gained Alexander’s confidence by his executive ability and firmness.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In contrast, Prince Bagration was respected throughout the army for his military talents. He retained an extraordinary presence of mind in the most desperate situations, and was known to endanger his life in circumstances where the odds were significantly against him. The rank and file knew this trait well; he had a charismatic personality that could fire his men to attempt the impossible. Unfortunately, Bagration had an uncontrollable temper. Although he was often calm, taciturn, and even restrained, his anger knew no bounds when he found an object worthy of his wrath. This contempt was often out of proportion to the situation. Bagration regarded Barclay’s tactics as ineffective and so he proposed the army go over to the offensive. Barclay, however, ignored his proposals, and Bagration’s rage continued increased.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bagration is often portrayed as a reckless general, whose only strategy was to blindly attack and confront the enemy. Known for his violent temper, some claimed he had limited strategic sense and moderate tactical skills."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent108",
      "id": "theft108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])])]), _vm._v(" This is incorrect. Bagration proved in a series of earlier campaigns that he was an equally effective offensive and defensive commander. However, in 1812, he was not informed of the overall strategy."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent109",
      "id": "theft109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])])]), _vm._v(" “I was neither provided with the essential information, nor acquainted with our policy,” he complained to Tsar Alexander."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent110",
      "id": "theft110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _vm._v(" Bagration appealed directly to Barclay for adequate information, but his requests were ignored. He wrote to Alexander Ermolov, Barclay’s Chief of Staff:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent"
  }, [_vm._v("I have written to you twice, but there is no answer. I asked the minister [Barclay de Tolly] where is he leading the army? I wrote to him, but there is no answer. I do not understand. What does it mean?! What is happening with you? Why do you neglect me? It is no time for jokes. If I write, it is necessary [for you] to answer."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent111",
      "id": "theft111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Lacking sufficient intelligence on the French invasion, Bagration believed it was possible to defeat Napoleon on the battlefield. However, he withdrew on his own initiative when faced with the advancing Grand Army. This proved vitally important to the Russians, for it provided the army with a three- to four-day advantage over the French before Bagrations’ route of retreat could be cut by the coordinated forces of King Jérôme and Marshal Davout. After successful actions at Mir and Moghilev, Bagration was convinced the Russian army could launch its own offensive. He appealed for an attack and criticized Barclay’s strategy in a series of letters to his Russian compatriots. For example, he wrote to Arakcheyev:")]), _vm._v(" "), _c('div', {
    staticClass: "extract"
  }, [_c('p', {
    staticClass: "extractTextNoIndent"
  }, [_vm._v("You will get no one in the army, or in Russia, to believe that we have not been betrayed. I cannot defend all Russia alone…. One feels ashamed…. If I cannot be supported, better have me released from the yoke and send someone else to command. But why torment the soldiers without purpose and satisfaction?"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent112",
      "id": "theft112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Unaware of the actual situation facing Barclay, Bagration complained to Ermolov, “One feels ashamed to wear the [Russian] uniform. I feel sick…. What a fool…. The minister [Barclay de Tolly] himself is running away, yet he orders me to defend all of Russia.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent113",
      "id": "theft113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])])]), _vm._v(" Commanders exchanged bitter letters,"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent114",
      "id": "theft114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])])]), _vm._v(" with Bagration, who focused his frustration on Tsar Alexander, as well. Bagration also knew his own chief of staff, Colonel Emmanuel Saint Priest, was in secret correspondence with the Tsar, informing him of the condition of the Second Western Army."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent115",
      "id": "theft115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Accompanied by an imposing escort of generals and aide-de-camps, Bagration reached Smolensk on 2 August, exhausted and ready to see an insult in every trifle. However, Barclay displayed unusual tact."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent116",
      "id": "theft116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])]), _vm._v(" To show his respect for Bagration, Barclay de Tolly met him wearing a parade uniform complete with medals, sash, sword, and plumed bicorne in hand. This unanticipated action had a tremendous effect on Bagration."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent117",
      "id": "theft117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])])]), _vm._v(" Both commanders apologized for any injustice he might have caused the other. Bagration praised Barclay’s withdrawal from Vitebsk, and Barclay complimented Bagration on the skillful manner in which he eluded Napoleon’s trap. Bagration seemed surprised by Barclay’s tact and his readiness to cooperate. He was pleased with this conversation and, though senior in rank, gallantly agreed to subordinate himself to Barclay de Tolly."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent118",
      "id": "theft118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])])]), _vm._v(" Furthermore, Bagration wrote to the Tsar suggesting that he appoint Barclay de Tolly Commander-in-Chief of all the armies, advising him that “a single overall command is necessary to save the fatherland.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent119",
      "id": "theft119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("After the failure of the counter-offensive at Smolensk on 8-12 August, and the subsequent surrender of the city on 19 August, relations between the two commanders deterioriated. Bagration was particularly enraged that Barclay de Tolly had broken his pledge not to surrender Smolensk. He complained to the Tsar that Barclay did not consider his suggestions and tried to mislead him."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent120",
      "id": "theft120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])])]), _vm._v(" Bagration wrote to Moscow Governor Feodor Rostopchin, “I do not rely on Barclay anymore and… can assure you that he will bring the enemy to [Moscow].”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent121",
      "id": "theft121",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])])]), _vm._v(" Two days after the battle of Smolensk, Bagration complained to Arakcheyev, “Your minister [Barclay de Tolly] may be good at ministerial affairs, but as a general he is not only bad, but simply worthless. I am truly going out of my mind from grief.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('a', {
    attrs: {
      "id": "theft122"
    }
  }, [_vm._v("122")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Anti-Barclay sentiments were also strong among senior officers who still intrigued for the appointment of Bagration to supreme command. The demands for Barclay’s dismissal showed signs of a mutiny."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent123",
      "id": "theft123",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])])]), _vm._v(" General Alexander Ermolov, who provided Bagration with information from the First Western Army headquarters, appealed to the Tsar requesting that Bagration replace Barclay de Tolly—unbeknownst to Bagration."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent124",
      "id": "theft124",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])])]), _vm._v(" Senior officers detested Barclay de Tolly, his associates, and the current strategy."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent125",
      "id": "theft125",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])])]), _vm._v(" Bagration’s consent to obey Barclay de Tolly irritated them. A contemporary recalled, “The reconciliation between two commanders infuriated all our generals and officers, who unanimously detested Barclay.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent126",
      "id": "theft126",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])])]), _vm._v(" These misguided officers tried to persuade Bagration to oppose Barclay de Tolly publicly. The Quartermaster General of the Second Western Army, Mikhail Vistitskii, stated that Bagration “was encouraged by the senior officers to replace Barclay by force.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent127",
      "id": "theft127",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Fortunately, Bagration rejected these treasonous suggestions and refused to openly engage Barclay de Tolly. But Bagration’s true feelings and passionate temper often came out in private letters to Arakcheyev and Rostopchin. “I have no power over the minister even though I am senior [in rank],” he complained. “When the Tsar departed [the army], he did not leave any instructions as to who should be in command in case the two armies united, and hence Barclay, as a Minister of War, would be superior.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent128",
      "id": "theft128",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Bagration also complained in a letter to Admiral Paul Tchichagov: “I am senior in rank, but His Majesty does not want to give overall command to one person; meanwhile he [Barclay] is allowed to do everything…. I call for the offensive, he for the retreat.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent129",
      "id": "theft129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])])]), _vm._v(" Alexander Ermolov urged Bagration to write directly to the Tsar and boldly suggest that he be named supreme commander of the Russian armies. “Please write to His Majesty [and appeal for the command]. You must fulfill your duty…. I will write to the Tsar and describe your deeds and impediments you have overcome. Take overall command of the armies…. ”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent130",
      "id": "theft130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Although Bagration’s secret ambition was undoubtedly to command the Russian armies, he hesitated to reach that high. The proud scion of the Bagration Kings of Georgia was a man of dignity. Too high and noble to commit willful insubordination, he rejected all appeals to write to the Tsar. Instead he wrote to Ermolov: “I will not write the Tsar asking for the command, because this would be attributed to my ambition and vanity, not my merit and abilities.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent131",
      "id": "theft131",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])])]), _vm._v(" Perhaps Bagration realized Alexander would never give him supreme command of the Russian army. He knew Alexander’s feelings toward him, especially in light of their conflict during the 1809 campaign in the Danube Valley, current disagreements on strategy, and his liaison with Alexander’s sister, Catherine."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent132",
      "id": "theft132",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The loss of Smolensk made Barclay’s position even more tenuous. According to Sir Robert Wilson, British commissioner to the Russian army, “The spirit of the army was affected by a sense of mortification and all ranks loudly and boldly complained; discontent was general and discipline relaxing. The removal [of Barclay de Tolly]… had become a universal demand.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent133",
      "id": "theft133",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])])]), _vm._v(" The retreat through Lithuania and Byelorussia was reluctantly accepted due to the enemy’s numerical superiority. However, the main theater of fighting was now on ancient Russian soil and the Holy City of Smolensk was in ruins. Thoughts of further retreat became unbearable, especially when after the successful actions (Mir, Klyastitsy, Romanovo, Moghilev, Polotsk, and Kobrin) that had taken place during the early stages of the retreat."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent134",
      "id": "theft134",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])])]), _vm._v(" These alleged successes fueled a determination to attack the French. Bagration wrote to Ermolov, “The retreat is intolerable and dangerous…. The army was in excellent condition, but now it is exhausted…. Ten days it marched on sandy terrain, in hot weather… surrounded by the enemy. Nevertheless, we defeated the adversary every time we opposed him! I do not understand these witty maneuvers. My maneuver is to seek and attack!”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent135",
      "id": "theft135",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Most Russian generals and officers opposed the surrender of Smolensk. Barclay’s favorite young general, Count Alexander Kutaysov, spoke with him on behalf of the senior officers and requested to continue the battle. Barclay de Tolly listened attentively and then replied, “Lets everyone mind his own business and I shall mind mine.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent136",
      "id": "theft136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])])]), _vm._v(" In Dorogobuzh, the corps commander complained to the Grand Duke Constantine about Barclay’s leadership. According to a contemporary, “soldiers were disappointed, downcast…. Everybody was concerned with the future of the army.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent137",
      "id": "theft137",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])])]), _vm._v(" To their own dishonor, many officers publicly slandered Barclay de Tolly. Grand Duke Constantine was even more disgraceful in his attempts to discredit the Commander-in-Chief, telling the rank and file, “we can do nothing [for] there is not a single drop of Russian blood in our commander’s veins.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent138",
      "id": "theft138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])])]), _vm._v(" In Dorogobuzh, Constantine brutally insulted Barclay in the presence of aide-de-camps and staff members, “You are "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("German")]), _vm._v(", a traitor, vermin, and you are betraying Russia!”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent139",
      "id": "theft139",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])])]), _vm._v(" Motivated by bigotry, jealousy, and self-interest, many Russian generals opposed Barclay de Tolly no matter what he did. Despite Barclay de Tolly’s loyalty and commitment to Russia, he was increasingly unpopular among the superstitious soldiers, who saw “irrefutable” evidence of his betrayal. In their eyes, Barclay de Tolly was “German” and therefore a traitor."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent140",
      "id": "theft140",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Considering the events prior to and during operations around Smolensk, Barclay de Tolly’s generalship saved the army and allowed it to pass to his successor intact and battle-worthy. At the beginning of the campaign, the ratio of forces was against the Russians. Luckily for Russia, Bagration and his supporters were not given high command, for a battle at that time may well have led to the destruction of both Russian armies, which in turn would have exposed all of Russia to Napoleon’s armies. Instead, Barclay opposed most of the army (and especially the Russian nobility) and continued his retreat deep into the heart of Russia. To his credit, Barclay stoically endured disgrace. Despite humiliation and insult, he assured Alexander he was devoted to the motherland and eager “to serve the country at any post or assignment.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent141",
      "id": "theft141",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])])]), _vm._v(" To justify his actions, Barclay wrote, “Had I been motivated by blind and reckless ambition, Your Majesty would probably have received a number of reports of battles fought, and nevertheless the enemy would still be at gates of Moscow without retaining sufficient forces to resist him.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent142",
      "id": "theft142",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])])])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The retreat toward Moscow during the summer of 1812 demonstrates well the competition and jealousy seething within the Russian army. On many occasions, senior Russian officers showed little judgment and behaved childishly. They accused Barclay of betraying Russia based on his alleged “German” origins. Ermolov recalled that the two Commanders-in-Chief had a passionate argument near Smolensk: Bagration yelled at Barclay, “You are German! That is why you do not care about Russia,” to which Barclay defiantly replied, “You are fool and do not even understand why you call yourself Russian.”"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent143",
      "id": "theft143",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])])]), _vm._v(" Georgian Bagration acted as an out-and-out Russian nationalist against Barclay, whose own origins were Scottish."), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent144",
      "id": "theft144",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])])]), _vm._v(" If Bagration and his supporters had gained control of the army, it could have had disastrous repercussions for the future of Russia and its leadership.")]), _vm._v(" "), _c('h2', {
    staticClass: "head"
  }, [_vm._v("Military Ranks")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Russian rank structure was determined by a decree levied by Peter the Great on 4 February 1722. This order provided the army branches and civilian service with rank equivalencies. When Peter launched reforms in the early 1700s, a new promotion system was required to organize the army and society. This was particularly important for noblemen, who were obligated to serve in the army under his decree. Peter the Great had two goals while forming his army along the European lines: to simplify the transfer from one branch of service to another, and to determine the precedence of officials in civilian service and court.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Table of Ranks"), _c('span', {
    staticClass: "font01"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/therussian_endnotes#thent145",
      "id": "theft145",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])])]), _vm._v(" was comprised of 14 chins, classes of ranks, and 262 service titles. It was organized by the military branches (infantry, cavalry, guard, artillery, and navy), civilian, and court positions. A system of properly addressing the ranks was also set up. The Guards, as a privileged corps, were given higher classes of rank than an equivalent rank in other military branches. Non-nobles particularly benefited from the Table of Ranks because it allowed sons of secretaries and scribes to be promoted through the ranks. The seventh class awarded men of non-noble descent the status of nobility ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dvorianskoe zvanie")]), _vm._v("). The Table was divided into three parts: classes XIV to IX were given ober officer (junior officer) ranks, classes VIII to V staff officer ranks, and classes IV to I general ranks. The rank of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Generalissimus")]), _vm._v(" was an exceptional distinction not included in the Table. During the 18th century, it was only awarded to three generals: Menshikov, Suvorov, and Prince Anton Ulrich von Braunschweig.")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The Table used specialized terminology. The official title literally translates to “Table of Rangs,” where the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("rang")]), _vm._v(" (rank) referred to a person’s status determined by his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chin")]), _vm._v(" (rank) and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("klass")]), _vm._v(" (class). In addition, the Table established a relative correspondence between the rank (chin) and position ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("dolzhnost")]), _vm._v("). A person would not be considered for a position unless he held a rank of appropriate class. In some cases, a promotion to a higher class also meant a promotion in position. Most classes had more than two ranks; each originally intended to describe a distinct position. The Table was modified several times throughout the two centuries it was used. In the late 19th century, the table contained 12 ranks and many titles of civilian positions were simplified. The Bolshevik government abolished the Table of Ranks in the 23 November and 29 December 1917 decrees.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d1a6020","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/therussian_thehistoryof32.vue
// module id = 189
// module chunks = 0